module.exports = __webpack_public_path__ + "img/wizard-loader.ae613eae.png";